function errorExtractor(error, reject) {
  if (error.error == "error.validation") {
    let err = error.fieldErrors
      .map((fielderror) => fielderror.field + " - " + fielderror.message)
      .join(", ");
    return reject(err);
  }
  if (error.error == "error.deleteGroup") {
    let err = error.fieldErrors;
    return reject(err);
  }
  return reject(error.description);
}

export { errorExtractor };
